// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__30ukX Text_base__DVupc Text_button__KX0B0","loading":"Button_loading__neFI3","spinner":"Button_spinner__s2_At","spin":"Button_spin__1Mwss"};